<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Datum terbeschikkingstelling
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul hier de datum in waarop het dividend beschikbaar is gesteld. Niet de datum waarop het dividend is
                uitbetaald.

                <div class="space20"></div>
                Let op! De uiterste aangifte- en betaaldatum lig 1 maand na de datum van terbeschikkingstelling.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Volgnummer
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Wij stellen een aangiftenummer samen op basis van o.a. het RSIN of fiscaal nummer, het jaar en maand van
                terbeschikkingstelling en een volgnummer. Met het volgnummer kan het aangiftenummer uniek gemaakt worden
                in het geval van meer aangiften in dezelfde maand. In de meeste gevallen kies je eerst voor volgnummer
                '1' en bij een volgende aangifte voor '2' etc.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Buitenlandse aandeelhouders
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een dividenduitkering aan het buitenland werkt in Nederland volgens dezelfde basisprincipes als een
                dividenduitkering aan binnenlandse aandeelhouders, maar er zijn extra regels en vaak belastingverdragen
                die invloed kunnen hebben op de uiteindelijke belastingheffing. De belangrijkste aspecten zijn:<br/>
                <div class="space20"></div>

                <b>1. Inhouding van Dividendbelasting</b><br/>
                Wanneer een Nederlandse vennootschap dividend uitkeert aan een buitenlandse aandeelhouder, moet de
                vennootschap dividendbelasting inhouden op het uitgekeerde dividend. Het standaardtarief voor
                dividendbelasting in Nederland is 15%. Dit betekent dat als bijvoorbeeld een buitenlandse vennootschap
                (of particulier) dividend ontvangt van een Nederlandse vennootschap, er 15% van het dividendbedrag als
                belasting wordt ingehouden.
                <div class="space20"></div>

                <b>2. Belastingverdragen</b><br/>
                Nederland heeft met veel landen belastingverdragen gesloten. Deze verdragen kunnen de hoogte van de
                dividendbelasting verminderen of zelfs uitsluiten, afhankelijk van de situatie. In een belastingverdrag
                wordt vaak een lagere bronbelastingtarief afgesproken dan het standaardtarief van 15%. De uiteindelijke
                belastingtarief is afhankelijk van de voorwaarden in het betreffende belastingverdrag.
                <div class="space20"></div>
                Voorbeeld: Als Nederland een belastingverdrag heeft met land X, en dat verdrag bepaalt dat de
                dividendbelasting niet hoger mag zijn dan 5%, dan wordt de inhouding op het dividend beperkt tot 5% in
                plaats van 15%. De buitenlandse aandeelhouder kan een teruggaaf aanvragen van het te veel ingehouden
                belastingbedrag (in dit geval 10%), via een verzoek bij de Belastingdienst.
                <div class="space20"></div>

                <b>3. Teruggaaf van Dividendbelasting</b><br/>
                Als de buitenlandse aandeelhouder te veel dividendbelasting heeft betaald (bijvoorbeeld doordat het
                belastingtarief hoger is dan het afgesproken tarief in het belastingverdrag), kan de buitenlandse
                aandeelhouder een teruggaaf aanvragen bij de Belastingdienst. Dit is mogelijk als de vennootschap in het
                buitenland het recht heeft om de belasting te verlagen volgens een belastingverdrag. De buitenlandse
                aandeelhouder moet dan vaak een verzoek indienen met de benodigde documenten.
                <div class="space20"></div>

                <b>4. Uitzonderingen en Vrijstellingen</b><br/>
                Er zijn situaties waarin dividendbelasting niet wordt ingehouden of waarin een
                inhoudingsvrijstelling
                van toepassing is:
                <div class="space20"></div>
                - Europese moeder-dochterregeling: Als de buitenlandse vennootschap die het dividend ontvangt in een
                ander
                EU-land is gevestigd, kan er sprake zijn van een vrijstelling van dividendbelasting op basis van de
                Europese moeder-dochterrichtlijn, mits de buitenlandse vennootschap minimaal 10% van de aandelen
                bezit
                (soms is het percentage zelfs lager). Dit is bedoeld om dubbele belasting te voorkomen binnen de EU.
                <div class="space20"></div>
                - Deelnemingsvrijstelling: Als de buitenlandse vennootschap minimaal 5% van de aandelen bezit in de
                Nederlandse vennootschap, en de deelneming voldoet aan de voorwaarden voor de
                deelnemingsvrijstelling,
                kan het dividend worden uitgekeerd zonder inhouding van dividendbelasting, mits de buitenlandse
                vennootschap belastingplichtig is in het buitenland en geen belasting ontwijkt. Dit kan ook van
                toepassing zijn bij landen met een gunstig belastingklimaat of bij bepaalde belastingverdragen.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4"
                    aria-expanded="false" aria-controls="collapse4">
                Afdrachtvermindering art. 11 of 12 Wet DB
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De afdrachtvermindering op grond van artikel 11 of 12 van de Wet op de dividendbelasting is een regeling
                die bedrijven in staat stelt om de dividendbelasting die zij hebben ingehouden op dividenduitkeringen te
                verminderen of terug te vorderen. Deze regeling geldt voor specifieke situaties waarin het
                belastingtarief lager is dan het standaardtarief van 15%, bijvoorbeeld door toepassing van
                belastingverdragen of andere vrijstellingen.
                <div class="space20"></div>
                De afdrachtvermindering is bedoeld om te voorkomen dat belasting wordt geheven over hetzelfde dividend
                door zowel de Nederlandse belastingautoriteiten als de belastingautoriteiten van het land van de
                ontvanger van het dividend (bijvoorbeeld bij een grensoverschrijdende dividenduitkering).

                <div class="space20"></div>
                <b>Artikel 11 Wet Dividendbelasting</b><br/>
                Artikel 11 van de Wet op de Dividendbelasting geeft de mogelijkheid om aftrekken van de
                dividendbelasting bij bepaalde uitkeringen van dividend aan buitenlandse vennootschappen of
                aandeelhouders.
                <div class="space20"></div>
                Kenmerken van de afdrachtvermindering volgens artikel 11:
                <ul>
                    <li>Het betreft een grensoverschrijdende situatie, waarbij een buitenlandse aandeelhouder dividend
                        ontvangtvan een Nederlandse vennootschap.
                    </li>
                    <li>Als er een belastingverdrag is tussen Nederland en het land van de buitenlandse aandeelhouder,
                        kan Nederland het dividendbelastingtarief verlagen tot het verdragstarief (bijvoorbeeld 5% in
                        plaats van 15%).
                    </li>
                    <li>De vennootschap die het dividend uitkeert kan dan minder dividendbelasting afdragen aan de
                        Belastingdienst, namelijk het verdragstarief in plaats van de standaard 15%. De buitenlandse
                        aandeelhouder kan het te veel ingehouden bedrag terugvorderen via een verzoek om een "teruggaaf
                        vanbelasting".
                    </li>
                </ul>

                In de praktijk wordt dit vaak toegepast bij multinationals die via belastingverdragen een lagere
                bronbelasting kunnen genieten dan de standaard 15%. Hierbij kan de belasting in Nederland vaak deels
                worden teruggevorderd door de buitenlandse vennootschap.
                <div class="space20"></div>
                <b>Artikel 12 Wet Dividendbelasting</b><br/>
                Artikel 12 gaat over de aftrek van dividendbelasting bij dividenduitkeringen aan een buitenlandse
                vennootschap die minimaal 5% van de aandelen bezit in de uitkerende vennootschap. Dit artikel kan
                worden ingeroepen wanneer een deelnemingsvrijstelling van toepassing is en de buitenlandse vennootschap
                recht heeft op een lagere belastingheffing vanwege bijvoorbeeld:
                <ul>
                    <li>Een Europese moeder-dochterrichtlijn.</li>
                    <li>Een belastingverdrag waarin een lagere dividendbelasting wordt afgesproken (bijvoorbeeld een
                        tarief van 0% of 5% in plaats van 15%).
                    </li>
                </ul>
                De vennootschap die het dividend uitkeert hoeft in dat geval geen dividendbelasting in te houden of
                kan de belasting verlagen tot het lagere verdragstarief. De afdrachtvermindering onder artikel 12 zorgt
                ervoor dat er geen dubbele belastingheffing is als de buitenlandse vennootschap de dividendbelasting
                effectief terugvordert.
            </div>
        </div>
    </div>

</div>
